import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <Box
      className="App"
      // sx={(theme) => ({
      //   // [theme.breakpoints.up("xs")]: { pt: "40px" },
      //   // [theme.breakpoints.up("sm")]: { pt: "64px" },
      // })}
    >
      <Outlet />
    </Box>
  );
}

export default Layout;
